// pages/treach/sections/FeedbackSection.jsx
import React from "react";

const FeedbackSection = () => {
  return (
    <div className="text-gray-200 text-sm">
      <p>💬 <strong>Customer Feedback</strong></p>
      <ul className="list-disc list-inside mt-3 text-gray-400">
        <li>“Saw your ad, loved it!” 😀</li>
        <li>“Offer wasn't clear.” 😕</li>
        <li>NPS: 7.8 / 10</li>
      </ul>
    </div>
  );
};

export default FeedbackSection;
